<template>
  <div>
    <el-dialog
      :title="title"
      :visible="isShowFrozenDialog"
      width="30%"
      @close="handleDialog"
      @open="init"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="金额" prop="amount">
          {{ $formatter.FenToYuan(null, null, item.amount, null) }}
        </el-form-item>
        <el-form-item label="订单号" prop="orderId">
          {{item.orderId}}
        </el-form-item>
        <el-form-item label="appId" prop="appId">
          {{item.appId}}
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            size="small"
            type="textarea"
            v-model="form.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowFrozenDialog: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    item: {
      type:Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        toStatus: '',
        remark: '',
      },
      title:'',
      rules: {
          remark: [
            { required: true, message: '请输入备注', trigger: 'blur' },
          ],
        },
    }
  },
  methods: {
    init(){
      if(this.item.freezeStatus=='00'){
        this.title='冻结'
      }else{
        this.title='解冻'
      }
    },
    handleDialog() {
      this.$refs['form'].resetFields()
      this.form = {
        toStatus: '',
        remark: '',
      }
      this.$emit('update:isShowFrozenDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
            orderId: this.item.orderId,
            appId:this.item.appId,
            freezeStatus:this.item.freezeStatus=='00'?'01':'00',
            amount:this.item.amount,
            freezeType:this.item.freezeType
          }
          this.$axios.post('/freezeBalance/precessFreezeBalance', params).then(res => {
            if (res.code === 200) {
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'success',
              })
              this.$emit('update:isShowFrozenDialog', false)
              this.$bus.$emit('refresh') //通知刷新
            } else {
              this.$notify.error({
                title: '提示',
                message: res.msg,
              })
            }
          })
        }
      })
    },
  },
}
</script>